<template>
	<component :is="`h${size}`" class="v-resume-title" :class="`v-resume-title--${size}`">
		{{ title }}
	</component>
</template>
<script>
export default {
	props: {
		size: String,
		title: String
	}
}
</script>
<style lang="scss" scoped>
.v-resume-title {
	font-weight: bold;
	color: #555;
	
	&--1 {
		font-size: 32px;
		line-height: 40px;
	}

	&--2 {
		font-size: 24px;
		line-height: 32px;
	}

	&--3 {
		font-size: 20px;
		line-height: 28px;
	}

	&--4 {
		font-size: 17px;
		line-height: 24px;
	}

	&--5 {
		font-size: 15px;
		line-height: 20px;
	}
}
</style>